import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppStore from '../store/app.store';
import toast from 'react-hot-toast';
import { IcEye, IcEyeOff } from '../components/ui/Icons';
import api from '../services/api';

export default function Login() {
  const [form, setForm]       = useState({ usuario: '', senha: '' });
  const [loading, setLoading] = useState(false);
  const [showSenha, setShowSenha] = useState(false);
  const setUsuarioLogado = useAppStore(s => s.setUsuarioLogado);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', {
        usuario: form.usuario.trim(),
        senha: form.senha,
      });
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      setUsuarioLogado(data.usuario);
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.error || 'Usuário ou senha inválidos.';
      toast.error(msg);
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#080c18',
      fontFamily: "'Inter', sans-serif",
      position: 'relative',
      overflow: 'hidden',
      padding: '24px 16px',
    }}>

      {/* Grade de pontos */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.035) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
      }} />

      {/* Brilho superior central */}
      <div style={{
        position: 'absolute', top: -240, left: '50%', transform: 'translateX(-50%)',
        width: 700, height: 700, borderRadius: '50%', pointerEvents: 'none',
        background: 'radial-gradient(circle, rgba(91,91,214,0.18) 0%, transparent 65%)',
      }} />

      {/* Brilho inferior */}
      <div style={{
        position: 'absolute', bottom: -180, right: '20%',
        width: 400, height: 400, borderRadius: '50%', pointerEvents: 'none',
        background: 'radial-gradient(circle, rgba(59,59,175,0.12) 0%, transparent 65%)',
      }} />

      {/* Card central */}
      <div style={{
        position: 'relative', zIndex: 1,
        width: '100%', maxWidth: 420,
        padding: '0 24px',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
      }}>

        {/* Ícone */}
        <div style={{
          width: 64, height: 64, borderRadius: 18, marginBottom: 24,
          background: 'linear-gradient(135deg, #3B3BAF 0%, #5B5BD6 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 8px 40px rgba(91,91,214,0.45)',
        }}>
          <img src="/icone-legacy.png" alt="" style={{ width: 40, filter: 'brightness(0) invert(1)' }} />
        </div>

        {/* Nome e subtítulo */}
        <h1 style={{
          color: '#fff', fontSize: 28, fontWeight: 800,
          letterSpacing: '-0.5px', marginBottom: 6, textAlign: 'center',
        }}>
          Legacy Hub
        </h1>
        <p style={{
          color: '#475569', fontSize: 13, fontWeight: 500,
          letterSpacing: '0.04em', textAlign: 'center', marginBottom: 48,
        }}>
          Assessoria de Marketing e Vendas
        </p>

        {/* Formulário */}
        <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <input type="text" style={{ display: 'none' }} aria-hidden="true" />
          <input type="password" style={{ display: 'none' }} aria-hidden="true" />

          <div>
            <label style={{
              display: 'block', fontSize: 11, fontWeight: 700,
              color: '#475569', marginBottom: 7,
              letterSpacing: '0.1em', textTransform: 'uppercase',
            }}>Usuário</label>
            <input
              type="text"
              value={form.usuario}
              onChange={e => setForm(p => ({ ...p, usuario: e.target.value }))}
              required
              autoFocus
              autoCapitalize="none"
              autoComplete="username"
              style={{
                width: '100%', padding: '13px 16px', boxSizing: 'border-box',
                borderRadius: 12, border: '1.5px solid #1e293b',
                fontSize: 14, color: '#f1f5f9', outline: 'none',
                background: '#0f172a', transition: 'all .18s',
              }}
              onFocus={e => { e.target.style.borderColor = '#5B5BD6'; e.target.style.boxShadow = '0 0 0 3px rgba(91,91,214,0.15)'; }}
              onBlur={e => { e.target.style.borderColor = '#1e293b'; e.target.style.boxShadow = 'none'; }}
            />
          </div>

          <div>
            <label style={{
              display: 'block', fontSize: 11, fontWeight: 700,
              color: '#475569', marginBottom: 7,
              letterSpacing: '0.1em', textTransform: 'uppercase',
            }}>Senha</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showSenha ? 'text' : 'password'}
                value={form.senha}
                onChange={e => setForm(p => ({ ...p, senha: e.target.value }))}
                required
                autoComplete="off"
                style={{
                  width: '100%', padding: '13px 44px 13px 16px', boxSizing: 'border-box',
                  borderRadius: 12, border: '1.5px solid #1e293b',
                  fontSize: 14, color: '#f1f5f9', outline: 'none',
                  background: '#0f172a', transition: 'all .18s',
                }}
                onFocus={e => { e.target.style.borderColor = '#5B5BD6'; e.target.style.boxShadow = '0 0 0 3px rgba(91,91,214,0.15)'; }}
                onBlur={e => { e.target.style.borderColor = '#1e293b'; e.target.style.boxShadow = 'none'; }}
              />
              <button type="button" onClick={() => setShowSenha(v => !v)} tabIndex={-1}
                style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#475569', padding: 0 }}>
                {showSenha ? <IcEyeOff size={15} /> : <IcEye size={15} />}
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading} style={{
            padding: '14px', borderRadius: 12, border: 'none', marginTop: 6,
            fontSize: 14, fontWeight: 700, color: '#fff', letterSpacing: '0.03em',
            cursor: loading ? 'not-allowed' : 'pointer',
            background: loading ? '#2d2f6e' : 'linear-gradient(135deg, #3B3BAF 0%, #5B5BD6 100%)',
            boxShadow: loading ? 'none' : '0 4px 24px rgba(91,91,214,0.4)',
            transition: 'all .2s',
          }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <p style={{ marginTop: 40, fontSize: 11, color: '#1e293b', textAlign: 'center' }}>
          © {new Date().getFullYear()} Legacy Assessoria · Todos os direitos reservados
        </p>
      </div>
    </div>
  );
}
